// Canvas fireworks burst — fires for 5 seconds on win. Mounts a fixed-position
// canvas, animates particles, removes itself when done.

interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  color: string;
  size: number;
}

const COLORS = ['#FF3304', '#FFFFFF', '#FF6B4D', '#FFD700', '#28AA23'];

export function launchFireworks(durationMs = 5000) {
  const canvas = document.createElement('canvas');
  canvas.style.position = 'fixed';
  canvas.style.inset = '0';
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = '9999';
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d')!;

  const particles: Particle[] = [];
  const startedAt = performance.now();
  let lastBurst = 0;
  let rafId = 0;

  function burst() {
    const cx = Math.random() * canvas.width;
    const cy = canvas.height * 0.2 + Math.random() * canvas.height * 0.3;
    const count = 60;
    for (let i = 0; i < count; i++) {
      const angle = (Math.PI * 2 * i) / count;
      const speed = 3 + Math.random() * 4;
      particles.push({
        x: cx,
        y: cy,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: 0,
        maxLife: 60 + Math.random() * 40,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        size: 2 + Math.random() * 2,
      });
    }
  }

  function tick(now: number) {
    const elapsed = now - startedAt;
    if (elapsed > durationMs && particles.length === 0) {
      cancelAnimationFrame(rafId);
      canvas.remove();
      return;
    }
    if (elapsed < durationMs && now - lastBurst > 600) {
      burst();
      lastBurst = now;
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.08;
      p.vx *= 0.99;
      p.life++;
      if (p.life > p.maxLife) {
        particles.splice(i, 1);
        continue;
      }
      const alpha = 1 - p.life / p.maxLife;
      ctx.globalAlpha = alpha;
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    rafId = requestAnimationFrame(tick);
  }
  rafId = requestAnimationFrame(tick);
}
